import type { Map as ImmutableMap } from 'immutable'
import type { Store } from 'redux'

import { setAuthToken, setAuthUserId } from '@library/auth'

/**
 * Map changes in Redux store to other sources
 */
export function subscribeState(store: Store) {
  let lastAuth: null | ImmutableMap<string, unknown> = null

  function listener() {
    const { auth } = store.getState()
    if (auth !== lastAuth) {
      const isAuthenticated = auth.get('isAuthenticated')
      const accessToken: string = auth.get('accessToken')
      setAuthToken(isAuthenticated ? accessToken : null)
      const authUserId: string = auth.get('id')
      setAuthUserId(isAuthenticated ? authUserId : null)
      lastAuth = auth
    }
  }

  store.subscribe(listener)
  listener()
}
